import _ from 'lodash';
import template from './dataKeys.html';

export default {
  name: 'datakeysButton',
  template,
  controller: DataKeysController,
  controllerAs: 'DataKeysCtrl',
  bindings: {
    dKeys: '<',
    toggleAction: '<'
  }
};

/* @ngInject */
function DataKeysController(PrettyNamesConst) {
  const vm = this;

  vm.closed = true;

  vm.dKeysArray = null;

  vm.$onInit = () => {
    vm.prettyNames = PrettyNamesConst;
  };
  vm.$onChanges = ({ dKeys }) => {
    if (dKeys.previousValue !== dKeys.currentValue) {
      vm.dKeysArray = _.keys(dKeys.currentValue);
    }
  };
  vm.expandTable = () => {
    vm.closed = !vm.closed;
  };
}
